import type { EditorAdapter, EditorOptions, EditorType } from './editor-adapter'
import { createCodeMirrorAdapter } from './adapters/codemirror-adapter'
import { createMonacoAdapter } from './adapters/monaco-adapter'
import { createAceAdapter } from './adapters/ace-adapter'

export type { EditorAdapter, EditorOptions, EditorType }

export type EditorMode = 'edit' | 'render'

export function createEditor(type: EditorType, container: HTMLElement, options: EditorOptions): Promise<EditorAdapter> {
  switch (type) {
    case 'monaco':
      return createMonacoAdapter(container, options)
    case 'codemirror':
      return createCodeMirrorAdapter(container, options)
    case 'ace':
      return createAceAdapter(container, options)
    default:
      return createMonacoAdapter(container, options)
  }
}

export function getEditorTypeName(type: EditorType): string {
  const names: Record<EditorType, string> = {
    monaco: 'Monaco',
    codemirror: 'CodeMirror',
    ace: 'Ace',
  }
  return names[type] ?? type
}